// Breadcrumb.jsx
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaTasks, FaTachometerAlt, FaFolderOpen,FaCheckCircle } from 'react-icons/fa'; // Import your icons
import { FaUsersGear } from 'react-icons/fa6';


const iconMap = {
  projects: <FaFolderOpen className="mr-1 text-yellow-500" />,
  tasks: <FaTasks className="mr-1 text-blue-500" />,
  dashboard: <FaTachometerAlt className="mr-1 text-red-400" />,
  assignbyme: <FaUsersGear className="mr-1 text-gray-700" />,
  donelist: <FaCheckCircle className="mr-1 text-emerald-500" />,
};

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  return (
    <nav className="text-gray-500 text-sm flex items-center space-x-1">
      <Link to="/projects" className="hover:underline flex items-center">
        <FaHome className="mr-1" /> <span>Home</span>
      </Link>

      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const label = decodeURIComponent(value);
        const icon = iconMap[label.toLowerCase()] || null;

        return (
          <span key={to} className="flex items-center space-x-1">
            <span className="mx-1">/</span>
            {isLast ? (
              <span className="text-gray-700 font-semibold flex items-center">
                {icon} <span className="ml-1 capitalize">{label}</span>
              </span>
            ) : (
              <Link to={to} className="hover:underline flex items-center">
                {icon} <span className="ml-1 capitalize">{label}</span>
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
